import React from 'react';
import { bool, shape, string } from 'prop-types';

const ImplementColor = ({
  className = '',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M4.40735 1.87207H5.90735L7.40096 7.87278L10.5872 7.87429L9.0932 1.87207H10.5932L12.75 10.5H14.25V9.375C14.25 8.75354 14.7537 8.25 15.375 8.25C15.9963 8.25 16.5 8.75354 16.5 9.375V13.125C16.5 13.7465 15.9963 14.25 15.375 14.25C14.7537 14.25 14.25 13.7465 14.25 13.125V12H12.75V14.25L11.25 15.75V12H9.75V14.25L8.25 15.75V12H6.75V14.25L5.25 15.75V12H3.75V13.125C3.75 13.7465 3.24628 14.25 2.625 14.25C2.00372 14.25 1.5 13.7465 1.5 13.125V9.375C1.5 8.75354 2.00372 8.25 2.625 8.25C3.24628 8.25 3.75 8.75354 3.75 9.375V10.5H5.25L5.90388 7.88449L4.40735 1.87207ZM7.125 9L6.75 10.5H11.25L10.875 9H7.125Z" fill="currentColor" />
  </svg>
);

ImplementColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default ImplementColor;
